import 'vendor'
import * as ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import Root from 'components/features/pfm/Root/Root'
import { captureException, initializeRaven } from 'helpers/errorHelpers'
import { rootContainer } from 'helpers/DOMHelpers'
import { initializeAjax } from 'helpers/observableAjaxHelpers'
import { IS_STATUS_APP } from 'helpers/userAgentHelpers'
import { remote, captureNavigationEvents } from 'helpers/mobileAppHelpers'
import { connectToRemote } from 'react-native-webview-messaging/dist/web'
import { getStore } from 'store'
import { SetDeviceInfoAction, SetupDeviceInfoAction } from 'actions/deviceActions'
import { isFeatureEnabled } from 'helpers/featureHelpers'

initializeRaven()

/* const whyDidYouRender = require('@welldone-software/why-did-you-render')
whyDidYouRender(React) */

declare const __API_URL__: string
initializeAjax(__API_URL__)

const renderApp = () => {
  ReactDOM.render(
    <Root />,
    rootContainer
  )
}

try {
  if (IS_STATUS_APP && !isFeatureEnabled('app')) {
    const metaNode = document.createElement('meta')
    metaNode.name = 'viewport'
    metaNode.content = 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, minimal-ui'
    if (document.head) {
      document.head.appendChild(metaNode)
    }
    document.body.classList.add('isStatusApp')

    window.initApp = (isPopup, deviceId) => window.initAppWithParams({
      launch: {
        isPopup,
      },
      device: {
        deviceId,
      },
    })

    window.initAppWithParams = ({
      launch: {
        isPopup,
      },
      device,
    }) => {
      getStore().dispatch(new SetDeviceInfoAction(device))

      if (isPopup) {
        remote.init(true)
        renderApp()
      } else {
        connectToRemote().then((webviewRemote) => {
          remote.init(false, webviewRemote)
          captureNavigationEvents()
          renderApp()
        })
      }
    }
  } else {
    getStore().dispatch(new SetupDeviceInfoAction())
    renderApp()
  }
} catch (error) {
  captureException(error)
}

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./components/features/pfm/Root/Root', () => {
    try {
      const NextApp = (require('./components/features/pfm/Root/Root') as any).default // tslint:disable-line:no-require-imports
      ReactDOM.render(
        (
          <AppContainer>
            <NextApp />
          </AppContainer>
        ), rootContainer
      )
    } catch (error) {
      captureException(error)
    }
  })
}
